<template>
  <NuxtLayout
    :name="route.meta.embedded ? 'embedded-service' : 'self-service'"
    :page="page"
  >
    <div class="flex max-tablet:block">
      <SideMenu class="max-tablet:hidden" />
      <NuxtPage />
    </div>
  </NuxtLayout>
</template>
<script setup lang="ts">
import { useCustomerStore } from '../../stores/customer'

definePageMeta({
  middleware: ['auth'],
})

const route = useRoute()
const router = useRouter()

const { t, setLocale } = useI18n()
const locale = route.params.locale as string
setLocale(locale)

const page: Page = {
  id: 0,
  title: t('dbc-head-profile'),
  path: '/kundenbereich',
  description: '',
  content: [],
  localizations: [
    {
      id: 0,
      title: t('dbc-head-profile'),
      path: 'kundenbereich',
      locale: 'de',
    },
    {
      id: 1,
      title: t('dbc-head-profile'),
      path: 'self-service',
      locale: 'en',
    },
  ],
  locale: locale,
}

usePageHead(page)

onBeforeMount(async () => {
  const customerStore = await useCustomerStore()
  await customerStore.getData()
  await customerStore.getContracts()
  await customerStore.getBahnBonusData()

  if (
    customerStore.tariffForChange &&
    customerStore.tariff &&
    customerStore.tariffForChange.name !== customerStore.tariff.name
  ) {
    router.push({ path: getPagePath['tariff']![locale] })
  } else {
    customerStore.removeBahnBonusData()
  }
})
</script>
